import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Home from "../Componentes/Home"
import LoginAhorrador from "../Componentes/Ahorradores/LoginAhorrador"
import GraficosSeguimientos from "../Componentes/Ahorradores/GraficosSeguimiento"
import ProtectedRoute from "./ProtectedRoute"



const Rutas = () => {


    return (
        <Router>
            <Fragment>

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/ahorrador-login" element={<LoginAhorrador />} />
                    <Route element={<ProtectedRoute />}>
                        <Route path="/seguimiento-ahorro" element={<GraficosSeguimientos />}></Route>
                    </Route>

                </Routes>

            </Fragment>
        </Router>
    )



}

export default Rutas